<template>
    <div class="page light page-current">
        <div class="navbar navbar-style-1 navbar-transparent">
            <div class="navbar-inner">
                <div @click="close" class="link back ripple-inset">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z"
                            fill="black"></path>
                    </svg>
                </div>
                <div class="title"></div>
                <div class="right">
                    <a href="#" class="link add-wishlist-btn">

                    </a>
                </div>
            </div>
        </div>
        <div class="page-content item-details pt-0" style="overflow: scroll">
            <div class="dz-banner-heading">
                <div class="overlay-black-light"
                     :style="{'background-image': 'url(' + require('@/assets/img/menus/pic1.jpg') + ')'}">
                    <img :src="image" class="bnr-img" @error="replaceByDefault" alt="">
                </div>
            </div>
            <div class="dz-banner-height"></div>
            <div class="fixed-content container">
                <div class="text-align-center">
                    <h4 class="ma-0">{{ name }}</h4>
                    <p v-if="item.weight" class="item-details">Waga: {{ item.weight }} g.</p>
                    <p v-if="item.volume" class="item-details">Pojemność: {{ item.volume }} ml.</p>
                    <p v-if="item.alcohol" class="item-details">Zawartość alkoholu: {{ item.alcohol }} %.</p>
                </div>

                <div class="text-align-center item-details-icon-handler">
                    <i v-if="item.is_vegetarian" class="iconmoon-vegeterian" @click="showIconDetails('vegeterian')"></i>
                    <i v-if="item.is_gluten_free" class="iconmoon-gluten-free"
                       @click="showIconDetails('gluten-free')"></i>
                    <i v-if="item.is_spicy" class="iconmoon-chili-pepper" @click="showIconDetails('chili-pepper')"></i>
                    <i v-if="item.is_low_calorie" class="iconmoon-low-calories"
                       @click="showIconDetails('low-calories')"></i>
                </div>


                <div v-if="!loading && item">
                    <div class="text-align-center">
                        <p class="">{{ item.description }}</p>
                    </div>
                    <div class="price-bx"><h3 class="price text-primary"><i class="las la-tag"></i> {{ item.price }} zł
                    </h3>
                        <div class="stepper stepper-init stepper-round">
                            <div @click="decreaseCounter" class="stepper-button-minus"></div>
                            <div class="stepper-input-wrap">
                                <input v-model="counter" type="text" min="0" max="100" step="1" readonly=""
                                       class="input-with-value"></div>
                            <div @click="increaseCounter" class="stepper-button-plus"></div>
                        </div>
                    </div>
<!--                    <p class="mt-0 mb-30">-->
<!--                        &lt;!&ndash;            <span @click="addToCart(item)" class="button-large button button-fill">&ndash;&gt;-->
<!--                        &lt;!&ndash;              {{$t("Add to cart")}} <span>{{totalPrice}} zł</span>&ndash;&gt;-->
<!--                        &lt;!&ndash;            </span>&ndash;&gt;-->
<!--                        <span-->
<!--                            @click="addToCart(item)"-->
<!--                            class="button-large button button-fill">-->
<!--              {{ $t("Add to cart") }} <span>{{ totalPrice }} zł</span>-->
<!--            </span>-->
<!--                    </p>-->
                    <div style="height:50px"></div>
                </div>
                <div v-else>
                    <div style="height:10px"></div>
                    <div style="height:10px"></div>
                    <div style="height:10px"></div>
                    <PuSkeleton height="15px"/>
                    <PuSkeleton height="15px"/>
                    <PuSkeleton height="15px"/>
                    <PuSkeleton height="15px"/>
                    <PuSkeleton height="15px"/>
                    <PuSkeleton height="15px"/>
                    <PuSkeleton height="15px"/>
                    <PuSkeleton height="15px"/>
                    <PuSkeleton height="15px"/>
                    <PuSkeleton height="15px"/>
                    <div style="height:15px"></div>
                    <PuSkeleton height="50px"/>
                    <PuSkeleton height="50px"/>
                </div>

                <vue-bottom-sheet
                    ref="iconDetails"
                    @opened="false"
                    @closed="false"
                    max-height="90%"
                >
                    <div class="padding-30">
                        <div v-if="activeIcon">
                            <div class="text-align-center">
                                <i v-if="activeIcon.icon === 'iconmoon-vegeterian'"
                                   class="iconmoon-vegeterian font-40"></i>
                                <i v-if="activeIcon.icon === 'iconmoon-gluten-free'"
                                   class="iconmoon-gluten-free font-40"></i>
                                <i v-if="activeIcon.icon === 'iconmoon-chili-pepper'"
                                   class="iconmoon-chili-pepper font-40"></i>
                                <i v-if="activeIcon.icon === 'iconmoon-low-calories'"
                                   class="iconmoon-low-calories font-40"></i>
                                <h2>{{ $t(activeIcon.name) }}</h2>
                                <p>{{ $t(activeIcon.description) }}</p>
                            </div>
                        </div>
                        <div style="height:400px"></div>
                    </div>
                </vue-bottom-sheet>


            </div>
        </div>
    </div>
</template>

<script>


import {BASE_API_URL} from "../appConstants";
import axios from "axios";
import router from "../router/router";

export default {
    name: "ItemDetails",
    props: ['id', 'image', 'name'],
    data() {
        return {
            item: {},
            counter: 1,
            totalPrice: 0,
            loading: true,
            activeIcon: null,
            iconsOptions: {
                "vegeterian": {
                    "name": "vegeterian",
                    "description": "vegeterian-description",
                    "icon": "iconmoon-vegeterian"
                },
                "gluten-free": {
                    "name": "gluten-free",
                    "description": "gluten-free-description",
                    "icon": "iconmoon-gluten-free"
                },
                "chili-pepper": {
                    "name": "chili-pepper",
                    "description": "chili-pepper-description",
                    "icon": "iconmoon-chili-pepper"
                },
                "low-calories": {
                    "name": "low-calories",
                    "description": "low-calories-description",
                    "icon": "iconmoon-low-calories"
                },
            }
        }
    },
    created() {
        this.getDetails();
    },
    methods: {
        replaceByDefault(e) {
            e.target.src = require('@/assets/img/menus/pic1.jpg')
        },
        close() {
            this.$emit("myEvent", "My parameter")
        },
        increaseCounter() {
            if (this.counter === 20) return;
            this.counter++;
            this.updateTotalPrice();
        },
        decreaseCounter() {
            if (this.counter === 1) return;
            this.counter--;
            this.updateTotalPrice();
        },
        updateTotalPrice() {
            this.totalPrice = this.counter * this.item.price;
        },
        addToCart(item) {
            this.$toast.success(this.$t('Added to cart'));
            item["count"] = this.counter;
            // this.$store.commit('addToCart', item);
            // this.$store.commit('cartStore/ADD_TO_CART', item);
            this.$store.dispatch('cartStore/SET_ITEM_TO_CART', item)
            this.close();
        },
        getDetails() {
            const endpoint = BASE_API_URL +
                'item?token=' + this.$store.state.companyData.token +
                '&item_id=' + this.id;

            axios.get(endpoint).then(
                response => {
                    this.loading = false;
                    this.item = response.data.item;
                    this.totalPrice = this.item.price;
                }
            ).catch(error => {
                this.loading = false;
                router.push('error');
                console.log(error);
            })
        },
        showIconDetails(icon) {
            this.activeIcon = this.iconsOptions[icon];
            this.$refs.iconDetails.open();
        }

    }
}
</script>

<style scoped>
.overlay-black-light {
    min-height: 300px;
    background-position: center;
}

</style>
